import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { HeaderComponent } from './components/header/header.component';
import { MainLayoutComponent } from './components/main-layout/main-layout.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { FederationShellComponent } from './components/federation-shell/federation-shell.component';
import { NoFederationComponent } from './components/no-federation/no-federation.component';
import { InvalidFederationComponent } from './components/invalid-federation/invalid-federation.component';

@NgModule({
  declarations: [
    HeaderComponent,
    MainLayoutComponent,
    SidebarComponent,
    FederationShellComponent,
    NoFederationComponent,
    InvalidFederationComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
  ],
  exports: [
    CommonModule,
    RouterModule,
    FormsModule,
    HeaderComponent,
    MainLayoutComponent,
    SidebarComponent,
    FederationShellComponent,
    NoFederationComponent,
    InvalidFederationComponent,
  ]
})
export class SharedModule {}
